import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { InventoryService }  from '../services/inventory.service';

@Component({
    template: require('./inventory-landing.html')
})
export class InventoryLanding implements OnInit {
    
    constructor(private route: ActivatedRoute,
                private router: Router,
                private service: InventoryService) {
    };

    ngOnInit() {

    }
}


// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory-landing/inventory-landing.component.ts